import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CererePriorityService } from '../cerere-priority.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { helper } from "../../../../../environments/helper";
import { CererePriorityAddPayload, CererePriorityUpdatePayload } from '../cerere-priority.interface';

@Component({
    selector: 'app-edit-cerere-priority',
    templateUrl: './edit-cerere-priority.component.html',
    styleUrls: ['./edit-cerere-priority.component.scss'],
})
export class EditCererePriorityComponent {
    // general error
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;

    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, [Validators.required]),
        color: new FormControl(this.data.color, [Validators.required]),
        time: new FormControl(this.data.time, [Validators.required]),
        slug: new FormControl(this.data.slug, [Validators.required]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<EditCererePriorityComponent>,
        private cererePriorityService: CererePriorityService,
        private notificationService: NotificationService,
        private authService: AuthService
    ) {
        this.processToken();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.cererePriorityService.setToken(token);
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name, color, time, slug } = this.form
            .value as CererePriorityAddPayload;
        const updatedRequestPriorityData: CererePriorityUpdatePayload = {
            id_cerere_priority: this.data.id_cerere_priority,
            name,
            color,
            time,
            slug
        };

        this.cererePriorityService
            .updateCererePriority(updatedRequestPriorityData)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    onHttpError(res: any) {
        if (res.errors && res.errors.message && res.errors.message.length > 0) {
            res.errors.message.forEach((msg: string) => {
                this.notificationService.warningSwal(
                    this.errorTitle,
                    msg,
                    this.errorIcon
                );
            });
        } else {
            let errorMessage =
                environment.config.customNotifications.generalMessages.error;
            this.notificationService.warningSwal(
                this.errorTitle,
                errorMessage,
                this.errorIcon
            );
        }
    }
}
